module.exports = __webpack_public_path__ + "img/5.497e4fe0.png";